


import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'


export default {

components: { Swiper, SwiperItem, XImg, LoadMore },
data() {

return {
audioSrc: null, //音频地址
audioPlaying: false, //音频播放状态
id: this.$route.query.id,
museum: null,
ac_poiIndex: -1, //选中的pois 默认-1
isOver3Line: false, //intro是否超过三行
isOpenLines: false 
};
},
filters: {
setDis(val) {
let dis = "距您" + (val / 1000).toFixed(1) + "km";
return dis;
}
},

computed: {},

watch: {},

methods: {
getIntangibleDetail(id) {
let that = this;
that.get({
url: that.GLOBAL.BASE_URL + "/api/v1/getIntangibleDetail",
params: {


lng: localStorage.getItem("lng"),
lat: localStorage.getItem("lat"),
id: id
},
isShowLoading: true,
success: function(data) {
console.log(data.data);
that.museum = data.data.data;
document.title = data.data.data.detail.name;
that.$nextTick(function() {

let height = document.getElementById("intro").clientHeight;
console.log(height);

let lineHeight =
document
.getElementById("intro")
.style.lineHeight.split("rem")[0] *
document.documentElement.style.fontSize.split("px")[0];
console.log(lineHeight);
if (height / lineHeight > 3) {
console.log("超出3行");
that.isOver3Line = true;
} else {
console.log("没超过3行");
that.isOver3Line = false;
}
});
}
});
},
nav(name, lat, lng) {
this.commonFun.openLocation(
name,


localStorage.getItem("lat"),
localStorage.getItem("lng"),
lat,
lng
);
},
playAudio(i) {
let that = this;
let audio = document.getElementById("myAudio");
if (
this.museum.pointsList[i].audio != null &&
this.commonFun.trim(this.museum.pointsList[i].audio) != ""
) {
if (i == this.ac_poiIndex) {
if (audio.paused) {
that.audioPlaying = true;
audio.play();
} else {
that.audioPlaying = false;
audio.pause();
}
} else {
this.ac_poiIndex = i;
let idx = this.museum.pointsList[i].audio.lastIndexOf(".");
this.audioSrc =
this.museum.pointsList[i].audio.substring(0, idx + 1) + "mp3";

audio.load();
audio.addEventListener("canplay", function() {
audio.play();
});
this.audioPlaying = true;

audio.addEventListener(
"ended",
function() {
that.ac_poiIndex = -1;
that.audioPlaying = false;
},
false
);
}
} else {
that.$vux.toast.text("暂无音频", "bottom");
}
},
jumpToPoi(id) {
this.$router.push({
path: "poi",
query: {
id: id
}
});
}
},

created() {
this.getIntangibleDetail(this.id);
},

mounted() {},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};



// WEBPACK FOOTER //
// ./src/pages/museum.vue